import type { FaireProductEntity } from "../../entity_types/product";

export const p_rre6xjx8dn: FaireProductEntity = {
  token: "p_rre6xjx8dn",
  type: "product",
  name: "Varsity Thanks Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/269e9ec8686e333a7c0e8467c29d7d6e4eeed9e015ce7a891913bd80479936e0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/68820ecf57ab59ae2d293f598b1e2a4f87efdd355af5572e7ddfc320dfc67912.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:36.600Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
